import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import type { QaPropertyEditState, QaProperty, QaList } from '../types'
import { getQaPropertyData, publishListing, cleanUpData } from './helpers'

// qaListReducer

const noQaPropertyConfig = {
  _id: null,
  userId: null,
  propertyId: null,
  qaId: null,
  images: null,
  listings: [],
  propertyData: [],
  isInitialized: false,
  isLoading: true,
  hasError: false,
}

interface SetPropertyEditPayload {
  _id: string
  userId: string
  propertyId: string
  qaId: string
  images: string
  listings: []
  propertyData: QaProperty[]
}

const initialState: QaPropertyEditState = { ...noQaPropertyConfig }

export const qaPropertyEditSlice = createSlice({
  name: 'QaProperty',
  initialState,
  reducers: {
    fetchQaListing: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setQaListing: (state, action: PayloadAction<SetPropertyEditPayload>) => {
      state._id = action.payload._id
      state.userId = action.payload.userId
      state.propertyId = action.payload.propertyId
      state.qaId = action.payload.qaId
      state.images = action.payload.images
      state.listings = action.payload.listings
      state.propertyData = action.payload.propertyData
      state.isLoading = false
      state.isInitialized = true
      state.hasError = false
    },
    fetchQaListingFailed: (state) => {
      state._id = null
      state.userId = null
      state.propertyId = null
      state.qaId = null
      state.images = null
      state.listings = []
      state.propertyData = []
      state.isInitialized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchQaProperty = (propId: string) => async (dispatch) => {
  try {
    dispatch(fetchQaListing())
    const pData = await getQaPropertyData(propId)
    const { _id, userId, images, listings, propertyId, qaId, propertyData } = pData
    dispatch(
      setQaListing({
        _id,
        userId,
        propertyId,
        qaId,
        images,
        listings,
        propertyData,
      }),
    )
  } catch (error) {
    message.error('Error gettings QA list')
    dispatch(fetchQaListingFailed())
  }
}

export const publishCouncilListing = (data: string, qaId: string, propertyId: string) => async (dispatch) => {
  try {
    const result = await publishListing(data)
    // setCsvData([])
    if (result.status === 'failed') {
      // setValidationErrors(result.errors)
      message.error('Update Failed')
      // dispatch(fetchListingFailed())
      if (result.message === 'columnsMissing') {
        //     setStatus(STATUS.VALIDATION_ERROR_COLUMN)
        message.error('Column missing')
        // dispatch(fetchListingFailed())
      } else {
        //      setStatus(STATUS.VALIDATION_ERROR_DATA)
        message.error('Data Error')
        // dispatch(fetchListingFailed())
      }
    } else {
      //    setStatus(STATUS.IN_PROGRESS)
      message.success('Property has been updated')
      if (cleanUpData(qaId, propertyId)) {
        message.success('List has been cleaned')
      }
      // dispatch(setListing({data}))
    }
  } catch (error: any) {
    // console.error(error)
    message.error(error)
  }
}

// Actions
export const { fetchQaListing, setQaListing, fetchQaListingFailed } = qaPropertyEditSlice.actions

export default qaPropertyEditSlice.reducer
